export const routeErrorHandler = (requestURL, error) => {
  let response;

  switch (true) {
    case requestURL.includes("/accounts"):
      console.error(
        "Error occurred on /accounts:",
        error.response?.data || error.message
      );
      response = {
        customMessage: "Error in accounts service.",
        status: error.response?.status,
        ...error.response?.data,
      };
      break;

    default:
      console.error("API Error:", error.response?.data || error.message);
      if (error.response) {
        response = {
          status: error.response?.status,
          data: error.response?.data,
          message: error?.message || "An error occurred",
        };
      } else {
        response = error.message || "An error occurred";
      }
      break;
  }

  return response;
};
